import React, { useRef } from "react";
import { CalendarDays } from "lucide-react";

function formatDisplayDate(value) {
  if (!value) return "Selecciona una fecha";
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return "Selecciona una fecha";
  return date.toLocaleDateString("es-MX", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

// Renders a button-like control showing the formatted date, while a
// transparent native date input on top handles taps/clicks so each
// platform's own date picker (mobile + desktop) opens on interaction.
export default function DateField({ id, value, min, onChange, className = "" }) {
  const inputRef = useRef(null);

  // Desktop browsers only auto-open the native picker when the tiny
  // built-in calendar glyph is clicked; force it open for any click.
  const openPicker = () => {
    const input = inputRef.current;
    if (input && typeof input.showPicker === "function") {
      try {
        input.showPicker();
      } catch (error) {
        // ignore browsers that reject programmatic showPicker calls
      }
    }
  };

  return (
    <div className={`relative ${className}`} onClick={openPicker}>
      <div className="flex w-full items-center justify-between gap-2 rounded-xl border border-blueGray-200 bg-blueGray-50 px-3 py-2.5 text-blueGray-800 transition focus-within:border-indigo-400 focus-within:bg-white">
        <span className={`truncate text-sm sm:text-base ${value ? "text-blueGray-800" : "text-blueGray-400"}`}>
          {formatDisplayDate(value)}
        </span>
        <CalendarDays size={18} className="shrink-0 text-indigo-500" />
      </div>
      <input
        ref={inputRef}
        id={id}
        type="date"
        value={value}
        min={min}
        onChange={onChange}
        aria-label="Fecha del ENARM"
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
      />
    </div>
  );
}
